// extracted by mini-css-extract-plugin
module.exports = {"alertCard":"alert_alertCard__27ChK","cardTitle":"alert_cardTitle__2-HiO","hrLine":"alert_hrLine__1LQX0","center":"alert_center__3qg-s"};